<template>
	<v-toolbar app height="56" color="white" class="app-header">
		<v-container fluid py-0 class="app-header-container">
			<v-layout row justify-space-between align-center>
				<v-flex xs6>
					<router-link to="/" class="brand-link">
						<span class="brand-icon"><v-icon color="white">security</v-icon></span>
						<span class="brand-copy">
							<strong>ACL</strong>
							<small>QUIPUSOFT SA</small>
						</span>
					</router-link>
				</v-flex>
				<v-flex xs6 text-xs-right>
					<div class="flex-item justify-end align-center">
						<v-btn
							flat icon
							class="notification-btn"
							color="primary"
							@click="openNotifications"
						>
							<span class="notification-quantity">
								{{ quantityNotifications }}
							</span>
							<v-icon>notifications_none</v-icon>
						</v-btn>
						<v-menu offset-y left content-class="profile-menu" min-width="230">
							<button type="button" class="profile-button" slot="activator">
								<span class="profile-image-container"><v-icon>person</v-icon></span>
								<span class="profile-copy">
									<strong>{{userName || 'Usuario'}}</strong>
									<small>Mi cuenta</small>
								</span>
								<v-icon size="18">keyboard_arrow_down</v-icon>
							</button>
							<v-card class="profile-menu-card">
								<v-card-title class="profile-menu-header">
									<span class="profile-menu-avatar"><v-icon>person</v-icon></span>
									<div>
										<strong>{{userName || 'Usuario'}}</strong>
										<small>Sesión activa</small>
									</div>
								</v-card-title>
								<v-divider></v-divider>
								<v-btn flat block class="logout-button ma-0" @click="logout">
									<v-icon size="19" class="mr-2">exit_to_app</v-icon>
									Cerrar sesión
								</v-btn>
							</v-card>
						</v-menu>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
	</v-toolbar>
</template>

<script>

function openNotifications() {
	this.$emit('open-notifications-event');
}

function profileImage() {
	return this.$store.getters.profileImage;
}

async function logout() {
	await this.$http.post('logout', {
		headers: {
			authorization: `Bearer ${this.token}`,
		},
	});
	window.localStorage.clear();
	this.$store.dispatch('clearUser');
	this.$router.push({ name: 'login' });
}

function companyLogo() {
	return this.getImageUrl(this.$store.getters.companyLogo);
}

function userName() {
	return this.$store.getters.userName;
}

export default {
	name: 'app-header',
	computed: {
		companyLogo,
		profileImage,
		userName,
	},
	methods: {
		logout,
		openNotifications,
	},
	props: {
		quantityNotifications: {
			default: 0,
			type: Number,
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
	@media (max-width: 599px) {
		margin-left: 0px !important;
		margin-right: 0px !important;
	}
}

.app-header {
	border-bottom: 1px solid #DCE7E2 !important;
	box-shadow: 0 2px 10px rgba(31, 55, 47, .07) !important;
}

.app-header-container {
	padding-left: 28px;
	padding-right: 28px;
}

.flex-item,
.brand-link {
	align-items: center;
	display: flex;
}

.brand-link {
	color: #263746;
	text-decoration: none;
	transition: opacity .16s ease, transform .16s ease;

	&:hover,
	&:focus {
		opacity: .9;
		transform: translateY(-1px);
	}
}

.brand-icon {
	align-items: center;
	background: linear-gradient(135deg, #1A4338, #12372E);
	border-radius: 10px;
	display: inline-flex;
	height: 34px;
	justify-content: center;
	width: 34px;
	box-shadow: 0 3px 8px rgba(26, 67, 56, .18);

	.icon {
		color: white;
		font-size: 20px;
	}
}

.brand-copy,
.profile-copy {
	display: flex;
	flex-direction: column;
	line-height: 1.2;
	margin-left: 9px;

	strong {
		font-size: 14px;
	}

	small {
		color: #7a8996;
		font-size: 10px;
	}
}

.profile {
	&-name {
		color: map-get($colors, black);
		font-family: map-get($fonts, open-bold);
		font-size: 13px;
		font-weight: bold;
		padding-right: 9px;
		vertical-align: super;
	}

	&-image-container {
		align-items: center;
		background: #EAF3EF;
		border-radius: 100%;
		display: inline-flex;
		height: 30px;
		justify-content: center;
		width: 30px;

		.icon {
			color: #1A4338;
			font-size: 19px;
		}
	}
}

.profile-button {
	align-items: center;
	background: transparent;
	border: 0;
	border-radius: 8px;
	cursor: pointer;
	display: inline-flex;
	outline: none;
	padding: 5px 7px;

	&:hover,
	&:focus {
		background: #EEF5F2;
	}
}

.profile-menu-card {
	border-radius: 8px;
	overflow: hidden;
}

.profile-menu-header {
	align-items: center;
	display: flex;
	padding: 14px;

	div {
		display: flex;
		flex-direction: column;
		line-height: 1.25;
		margin-left: 10px;
	}

	strong {
		color: #34495e;
		font-size: 13px;
	}

	small {
		color: #7a8996;
		font-size: 11px;
	}
}

.profile-menu-avatar {
	align-items: center;
	background: #EAF3EF;
	border-radius: 50%;
	display: inline-flex;
	height: 34px;
	justify-content: center;
	width: 34px;

	.icon {
		color: #1A4338;
		font-size: 20px;
	}
}

.logout-button {
	color: #d64242;
	height: 42px;
	justify-content: flex-start;
	text-transform: none;
}

.notification {
	&-btn {
		background-color: transparent !important;
		border-radius: 8px;
		box-shadow: none;
		height: auto;
		margin: 0 12px 0 0;
		min-width: auto;
		width: auto;

		&:hover,
		&:focus {
			background: #EEF5F2 !important;
		}
	}

	&-quantity {
		background-color: map-get($colors, border);
		border-radius: 100%;
		color: white;
		font-family: map-get($fonts, lato-regular);
		font-size: map-get($sizes, small10);
		height: 12px;
		right: 0px;
		line-height: 10px;
		position: absolute;
		text-align: center;
		top: 0px;
		width: 12px;
		z-index: 2;
	}
}

@media (max-width: 600px) {
	.app-header-container {
		padding-left: 10px;
		padding-right: 10px;
	}

	.brand-copy small,
	.profile-copy {
		display: none;
	}
}

.btn-notification {
	color: map-get($colors, base);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-header.vue